// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b12f7c8d","388":"697d0fe1","414":"c84ccdb8","551":"7d1a0489","708":"9a148ac1","712":"cfe10618","787":"6720b374","919":"05317a16"}[chunkId] + ".chunk.js";
};